export default "__VITE_ASSET__CLGwtiO5__"